import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import styled from "styled-components";
import  './styles.scss'

// Error styling
const ErrorWrapper = styled.span`
  color: #f00;
  display: block;
  font-size: 12px;
  margin: 8px 0;
`;

// Styled Wrapper for the DatePicker
const DatePickerWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;

  .custom-datepicker {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }

  .calendar-icon {
    position: absolute;
    top: 23px;
    right: 10px;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAABFdJREFUSA21lk1MXFUUx+8wb2aYdBwKFGRkiOimbTSGYtOVTQjfBE2ICe4acdk0Xdm6MCZG3Bhr0A2JIe5oN8WwKgSIEJu4cFFMjV+kwdoGFxpMCnSa4gzM+Du3745v3rsjz6S9yZt77v/8zzn3nHvefRNRltHf399cU1NzolAoREQdi8VKrL+fn5//w0LXEDaHIpHIqb29vYQAjuOoaDR6G5tbNhvHBmL8RjKZHBNjGaVSSeXz+auIH2vA8gPnJIEu1dbWKjZgbH6EOmahqxobuL+/H6urq1OTk5NqampKNTU1KbKP2bgGI7DWj4+Pa5vOzk61u7trTUxsnJ6ennfZ4QvIukQCknGD7DqbzSpKLCUTuK+3t/eECLZB4ENsWLW0tKhMJqOomGT+PDZf+vh/w/2JajqvF4vFHKRvDAH5GHJaHElgd2whr5mFf4bbAtbEpssqAjz024C9QiJHHQQhri8tLb1nLLq7u8+zoXaaSkMSnM19C+cjw/HPVO40DjvkjGVIf2Dzu9ev4H19fV8Qs8OcQTktUTISuVxOTUxM6DJvbW2Jo/JRPKJU/rK5pByP9EQ6nVZra2sqHo/bbHQsE7jCC5ne3N7e7pidndWvk3teqxUk3wKbOzTgD4uLiwkyKpE5BYiWj89HVyZw0avA+CvW8oQe7vv6VggDHUsHpkRHuABe8xrRLPrwDcbudfZmbZtD2hwRW9NcWeT3vc6kobzDbUIvFJD/j40jDYHTX+jACwFPTwBgc58Q87gpdX55efnPJxAn4JIjzQuo60nGB55fV1fX4dHRUX2FBbwBcEPVwTHNaqNozMSqPMgq9IGBgQyvy5WdnZ2XbZSRkZHDlG86kUh02fQ2LFRgdulwNk8zp2xOCBrleYauTtv0NixQmsHBwXaIaS6DMl+cElTWz3E1vlRWuAK3XL2I8Nr8ei6SQmtr6zo32r8O4VYE5gyT3Fif8s628bhuH32PJTCOz4KfLSs8gqs/g/6MgeHLd7y4sbExBvazwWWuCDwzM7PLB+ICTp7yknCQ4fkQ/HPwG16dyBxDPbpLvJKX4X1t9LIZdIVUKrVuMDNXBAYsrays/GqUZh4aGvqL85MPxvrCwsJNg5uZ5msQmSB3+BoF9IbnnUM1lzEggwNfO8M9aPZnrCj1s3wCK0pNthnXUTsXwIsWp7q5KHWbXy+l3tzcvL26unpgc31GSduktN4h58U458WM7Oqk1G+CyaOHNBd+is3NzWMA/91cnNdFdp4WIzMkY5x+wHoKPNBc4A0El38nV9BfN3Yyg4drLr7FgQ6kubJSAYLform+8zoWeXh4uJ7XRsTfsA/oReEfoZqLyyRO+cXW9ldGskpIhXji/gDV1qECcwffo/zXee7aHDU2Nt5Ht4IuUC0bXzDd1exUd0410tzc3D10b1fTT09PP0D3TjW9FzexIrT/DUqVQ1n1P7PX8DHIxwiekoyvIbzKfPIxOA3r4to/s+auuGLsttwAAAAASUVORK5CYII=");
    background-size: cover;
    cursor: pointer;
  }
`;

const DateTimePicker = ({
  input,
  meta,
  selectedDate,
  onSetDateTime,
  showTimeSelect = true,
  dateFormat = "yyyy-MM-dd HH:mm:00",
  timeIntervals = 15,
  ...props
}) => {
  const [date, setDate] = useState(null);

  useEffect(() => {
    if (selectedDate) {
      setDate(moment(selectedDate).toDate());
    }
  }, [selectedDate]);

  let minTime = moment().toDate()
  if (date) {
    if (moment().isSame(date, "day")){
      minTime = moment().toDate()
    }else{
      minTime = moment().startOf("day")
    }
  }
  return (
    <DatePickerWrapper>
      <DatePicker
        {...props}
        className="custom-datepicker"
        selected={date}
        onChange={(newDate) => {
          if (moment().isBefore(newDate)) {
            setDate(newDate);
            if (input?.onChange) input.onChange(newDate);
            if (onSetDateTime) onSetDateTime(newDate);
          }
        }}
        disabledKeyboardNavigation
        showTimeSelect={showTimeSelect} // Enables time selection
        timeFormat="HH:mm:00" // 24-hour format (use "hh:mm aa" for 12-hour format)
        timeIntervals={timeIntervals} // Time selection in 15-minute steps
        timeCaption="Time" // Label for time picker
        dateFormat={dateFormat} // Format for date and time
        minTime={minTime}
        maxTime={new Date().setHours(23, 59, 59, 999)}
        placeholderText={props.placeholder}
      />
      <div className="calendar-icon" onClick={() => document.querySelector(".custom-datepicker").focus()} />
      {meta?.touched && meta?.error && (
        <ErrorWrapper className="error-message">{meta.error}</ErrorWrapper>
      )}
    </DatePickerWrapper>
  );
};

DateTimePicker.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  selectedDate: PropTypes.instanceOf(Date),
  onSetDateTime: PropTypes.func,
  showTimeSelect: PropTypes.bool,
  dateFormat: PropTypes.string,
  timeIntervals: PropTypes.number,
};

export default DateTimePicker;
